window.theme = window.theme || {};

theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    "shopify:section:load",
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    "shopify:section:unload",
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    "shopify:section:select",
    this._onSelect.bind(this)
  );
  document.addEventListener(
    "shopify:section:deselect",
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    "shopify:block:select",
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    "shopify:block:deselect",
    this._onBlockDeselect.bind(this)
  );
};

theme.Sections.prototype = Object.assign({}, theme.Sections.prototype, {
  _createInstance: function (container, constructor) {
    var id = container.getAttribute("data-section-id");
    var type = container.getAttribute("data-section-type");

    constructor = constructor || this.constructors[type];

    if (typeof constructor === "undefined") {
      return;
    }

    var instance = Object.assign(new constructor(container), {
      id: id,
      type: type,
      container: container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function (evt) {
    var container = document.querySelector(
      '[data-section-id="' + evt.detail.sectionId + '"]'
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function (evt) {
    this.instances = this.instances.filter(function (instance) {
      var isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === "function") {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onSelect === "function"
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onDeselect === "function"
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockSelect === "function"
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function (evt) {
    // eslint-disable-next-line no-shadow
    var instance = this.instances.find(function (instance) {
      return instance.id === evt.detail.sectionId;
    });

    if (
      typeof instance !== "undefined" &&
      typeof instance.onBlockDeselect === "function"
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register: function (type, constructor) {
    this.constructors[type] = constructor;

    document.querySelectorAll('[data-section-type="' + type + '"]').forEach(
      function (container) {
        this._createInstance(container, constructor);
      }.bind(this)
    );
  },
});

theme.collectionSlider = (function () {
  function sliderProduct(e) {
    let sliderContainer = "",
      extraLargeDesktopShow = 4,
      largeDesktopShow = 3,
      tabletShow = 3,
      mobileShow = 2,
      sliderAutoplay = e.dataset.autoplay,
      loopSelector = e.dataset.sliderLoop,
      loopInit = false,
      autoPlayValue = false,
      autoPlayTime = parseInt(e.dataset.autoplayTime);

    if (sliderAutoplay == "true") {
      autoPlayValue = {
        delay: autoPlayTime,
      };
    }

    if (loopSelector == "true") {
      loopInit = true;
    }

    if (e.dataset.sliderEnable === "true") {
      sliderContainer = e.querySelector(".productSlider");
      extraLargeDesktopShow = parseInt(e.dataset.showExtraLarge);
      mobileShow = parseInt(e.dataset.showMobile);
      if (typeof e.dataset.showTablet !== "undefined") {
        tabletShow = e.dataset.showTablet;
      } else {
        tabletShow = extraLargeDesktopShow;
      }
    } else {
      sliderContainer = false;
    }

     // Pagination configuration
    let paginationType = e.dataset.paginationType || 'bullets';
    let showPagination = e.dataset.showPagination === 'true';
    let paginationConfig = {};
    if (showPagination) {
        if (paginationType === 'progress-bar') {
          paginationConfig = {
            el: e.querySelector(".swiper-pagination"),
            type: "progressbar",
          };
        } else {
          let paginationTypeValue = paginationType === 'counter' ? 'fraction' : 'bullets';
          paginationConfig = {
            el: e.querySelector(".swiper-pagination"),
            clickable: true,
            type: paginationTypeValue,
          };
        }
      } else {
        paginationConfig = false;
      }

    var featuredCollection = new Swiper(sliderContainer, {
      loop: true,
      slidesPerView: mobileShow,
      spaceBetween: 20,
      autoplay: autoPlayValue,
      pagination: paginationConfig,
      navigation: {
        nextEl: e.querySelector(".swiper-button-next"),
        prevEl: e.querySelector(".swiper-button-prev"),
      },
      breakpoints: {
        640: {
          slidesPerView: mobileShow,
        },
        750: {
          slidesPerView: tabletShow,
        },
        992: {
          slidesPerView: extraLargeDesktopShow,
        },
      },
    });    

    if (!sliderContainer == false && sliderAutoplay == "true") {
      sliderContainer.addEventListener("mouseenter", (e) => {
        featuredCollection.autoplay.stop();
      });
      sliderContainer.addEventListener("mouseleave", (e) => {
        featuredCollection.autoplay.start();
      });
    }
    // Slide thumbnail height
    const slideThumbHeight = () => {
      const proudctThumbnails = e.querySelectorAll(".card--client-height");
      if (proudctThumbnails.length > 0) {
        const productThumbnailHeight = proudctThumbnails[0];
        e.style.setProperty(
          "--slider-navigation-top-offset",
          `${productThumbnailHeight.clientHeight / 2}px`
        );
      }
    };
    slideThumbHeight();
    window.addEventListener("resize", () => {
      slideThumbHeight();
    });
  }
  return sliderProduct;
})();

document.addEventListener("DOMContentLoaded", function () {
  let sections = new theme.Sections(),
    headerSearchModule = new theme.Sections(),
    headerCartModule = new theme.Sections(),
    headerStickyModule = new theme.Sections(),
    headerMainMenu = new theme.Sections();

  sections.register("announcement-bar", theme.announcement);
  sections.register("header", theme.headerSection);
  headerSearchModule.register("header", theme.headerSearch);
  headerStickyModule.register("header", theme.headerSticky);
  headerMainMenu.register("header", theme.headerMainMenuModule);
  sections.register("footer", theme.footerSection);
  sections.register("slideShow", theme.SlideShow);
  sections.register("collection-product", theme.collectionProduct);
  sections.register("product-slider", theme.collectionSlider);
  sections.register("accordion", theme.accordion);
  sections.register("blog", theme.blog);
  sections.register("lookbook", theme.lookbookSlider);
  sections.register("timeline", theme.timelineSlider);
});

var productCountdown = class extends HTMLElement {
  constructor() {
        super();       
    }
    connectedCallback() {
       this.invertory_el = document.body.querySelector('.variant-inventory-text');
       if(this.invertory_el){
        setInterval(() => {
            this._msToTime();
          }, 1000);
       }
    }
  _msToTime = function() {
            var invertory_el = this.invertory_el;
            var invertory_text = invertory_el.innerHTML;
            
            // var custom_shipping_text =  $('body').find('.custom-shipping-text').html();
            var order_time = '';
            var order_el = this;
            var boise_holidays_flag = false;
            

            // if(custom_shipping_text.length) {
            //   invertory_text = custom_shipping_text;
            // }
           
            
            if(invertory_text.indexOf('Boise') + 1) {
              order_time = '6pm';
                boise_holidays_flag = true;
            } else if (invertory_text.indexOf('Chicago') + 1) {
              order_time = '3:00pm';
            }else if (invertory_text.indexOf('Augusta') + 1) {
              order_time = '2:00pm';
            } else if (invertory_text.indexOf('NC') + 1) {
              order_time = '1:30pm';
            } else {
              order_time = '6pm';
            }

            var cutoff_time = Date.today().at(order_time);
            var current_time = moment.tz("America/New_York").format('LTS'); // time zona New York 
                      
          
            var current_time_with_day = moment.tz("America/New_York").format('LLLL');
            var current_time_with_day_datajs = Date.parse(current_time_with_day); // convert time to date.js
            var compare = Date.compare(current_time_with_day_datajs, cutoff_time);  

              if(compare == 1){
                current_time = Date.parse("11:59:59 PM"); // convert time to date.js
              }else{
                current_time = Date.parse(current_time); // convert time to date.js
              }
            
           
            var hourDiff = cutoff_time - current_time; //in ms
            var seconds = parseInt((hourDiff / 1000) % 60),
                minutes = parseInt((hourDiff / (1000 * 60)) % 60),
                hours = parseInt((hourDiff / (1000 * 60 * 60)) % 24);           
			
            
            
           
            if( Date.today().is().saturday() || Date.today().is().sunday() || ( Date.today().is().friday()  && hourDiff <= 0) ) {
              var next_monday = Date.parse("next monday").toString("ddd MMM d");

              if(boise_holidays_flag) {
                var holidays = this.getAttribute("boise_holidays_day"); 
              } else {
                var holidays = this.getAttribute("holidays"); 
              }

              var flag_holiday = true;
              if(holidays == null || holidays == '') {
                flag_holiday = false;
              }

              if(flag_holiday) {
                holidays = holidays.split(','); 

                var day_today = Date.today().next().monday();
              				
                for(var i = 0; i < holidays.length; i++) {               
                  if(Date.compare(day_today, Date.parse(holidays[i])) == 0) {
                    day_today = day_today.add(1).day();                       
                  } 
                }

                var next_working_day = day_today.toString("ddd MMM d");
                order_el.innerHTML = 'Order now to ship ' +  next_working_day;
              } else {
                order_el.innerHTML = 'Order now to ship ' +  next_monday;
              }


              
            }else {

              if(boise_holidays_flag) {
                 var holidays = this.getAttribute("boise_holidays_day"); 
              } else {
                var holidays = this.getAttribute("holidays"); 
              }

                var flag_holiday = true;
                if(holidays == null || holidays == '') {
                  flag_holiday = false;
                }
               
                if(flag_holiday) {
                  holidays = holidays.split(','); 

                  var day_today = Date.today();
                  var next_day = Date.today().add(1).day(); 						
                  
                  var working_day = true;
                  
                  for(var i = 0; i < holidays.length; i++) {               
				
                    if(Date.compare(day_today, Date.parse(holidays[i])) == 0) {
                      working_day = false;
                      day_today = day_today.add(1).day();                       
                      if(day_today.is().saturday() || day_today.is().sunday() || Date.today().is().sunday()) { 
                        var next_monday = Date.parse("next monday").toString("ddd MMM d");
                        order_el.innerHTML ='Order now to ship ' + next_monday;
                      }  else {
                          order_el.innerHTML = 'Order now to ship tomorrow';
                      }      
                      
                      
                     } else if(Date.compare(next_day, Date.parse(holidays[i])) == 0) {
                      working_day = false;
                      next_day = next_day.add(1).day(); 
                      if(next_day.is().saturday() || next_day.is().sunday()) { 
                        if(!day_today.is().saturday() && !day_today.is().sunday()  && hourDiff > 0 )  {
                          order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';		                        
                        } else {
                          var next_monday = Date.parse("next monday").toString("ddd MMM d");
                          var next_monday_date =  Date.parse("next monday");
                          if(typeof holidays[i+1] != "undefined"){
                          if(Date.compare(next_monday_date, Date.parse(holidays[i+1])) == 0){
                            //console.log("111");
                            next_monday_date = next_monday_date.add(1).day(); 
                            var next_monday_str = next_monday_date.toString("ddd MMM d")
                            order_el.innerHTML = 'Order now to ship ' + next_monday_str;
                          }else{
                            //console.log("222");
                          order_el.innerHTML = 'Order now to ship ' + next_monday;
                          }
                          }else{
                             order_el.innerHTML = 'Order now to ship ' + next_monday;
                          }
                        }
                      }  else {
                        if(hourDiff > 0) {               
                          order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';
                        } else  { 
                          order_el.innerHTML = 'Order now to ship ' + Date.parse(next_day).toString("ddd MMM d");  
                        }
                      }                      
                    }
                  }

                  if(working_day) {

                    if(hourDiff > 0) {               
                      order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';
                    } else  { 
                      order_el.innerHTML = 'Order now to ship tomorrow';
                    }
                  }

                } else {
                  if(hourDiff > 0) {               
                    order_el.innerHTML = 'Order in the next <b>' +  hours + ' hours ' + minutes + ' mins ' + seconds + ' seconds </b>  to ship today';
                  } else  { 
                    order_el.innerHTML = 'Order now to ship tomorrow';
                  }
                }            
            }
  }
};
window.customElements.get("product-countdown") || window.customElements.define("product-countdown", productCountdown);

class ProductAppSwatches extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var swatches = this.querySelectorAll('.swatch-element');
    var productMainAllImages = this.closest('.product').querySelectorAll('.product__media-item .product__media img');
    var productInventoryMessage = this.closest('.product').querySelector('.product__inventory > span');
    var productInventoryProgressbar = this.closest('.product').querySelector('.stock_progress_bar');

    var productSKU = this.closest('.product').querySelector('.sku__unique_code');
    var swatchesOptionValue;

    if (productMainAllImages.length) {
      productMainAllImages.forEach(function(item) {
        item.setAttribute('data-src', item.getAttribute('src'));
        item.setAttribute('data-srcset', item.getAttribute('srcset'));
      });
    }

    if (swatches.length) {
      swatches.forEach(function(item) {
        item.addEventListener("mouseenter", function() {
          var itemImg = this.querySelector('.swatch-image-block img');
          var productMainImage = this.closest('.product').querySelector('.product__media-item.is-active .product__media img');
          var swatchesOptionValue = this.closest('.swatch-links').querySelector('.header .current');
          if (itemImg && productMainImage) {
            productMainImage.setAttribute('src', itemImg.getAttribute('src'));
            productMainImage.removeAttribute('srcset');
          }

          if (swatchesOptionValue) {
            swatchesOptionValue.innerHTML = this.getAttribute('data-value');
          }

          if (!this.classList.contains('current')) {
            if (productInventoryMessage) {
              productInventoryMessage.innerHTML = this.getAttribute('data-progress-message');
              productInventoryMessage.style.color = this.getAttribute('data-inventory-color');
            }

            if (productInventoryProgressbar) {
              productInventoryProgressbar.style.background = this.getAttribute('data-progress-foregraund');
              productInventoryProgressbar.style.width = this.getAttribute('data-progress-width');
            }

            if (productSKU) {
              productSKU.innerHTML = this.getAttribute('data-sku-text');
            }
          }
        });

        item.addEventListener("mouseleave", function() {
          var productMainImage = this.closest('.product').querySelector('.product__media-item.is-active .product__media img');
          var swatchesOptionValue = this.closest('.swatch-links').querySelector('.header .current');
          if (productMainImage) {
            productMainImage.setAttribute('src', productMainImage.getAttribute('data-src'));
            productMainImage.setAttribute('srcset', productMainImage.getAttribute('data-srcset'));
          }

          if (swatchesOptionValue) {
            swatchesOptionValue.innerHTML = swatchesOptionValue.getAttribute('data-og');
          }

          if (productInventoryMessage) {
            productInventoryMessage.innerHTML = productInventoryMessage.getAttribute('data-message');
            productInventoryMessage.style.color = null;
          }

          if (productInventoryProgressbar) {
            productInventoryProgressbar.style.background = null;
            productInventoryProgressbar.style.width = productInventoryProgressbar.getAttribute('data-width');
          }

          if (productSKU) {
            productSKU.innerHTML = productSKU.getAttribute('data-sku');
          }
        });
      });
    }
  }
}

customElements.define("product-app-swatches", ProductAppSwatches);

class ProductShippingInfo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    var _this = this;
    var zipCodeButton = this.querySelector('.customer_zip_code_row');
    var infoForm = this.querySelector('.customer_info_form__wrapper');
    if (zipCodeButton) {
      zipCodeButton.addEventListener("click", function() {
        if (infoForm) {
          infoForm.classList.toggle('active');
        }
      });
    }
            	

              var all_counties_arr = [ 
                {name: 'Afghanistan', code: 'AF'}, 
                {name: 'Åland Islands', code: 'AX'}, 
                {name: 'Albania', code: 'AL'}, 
                {name: 'Algeria', code: 'DZ'}, 
                {name: 'American Samoa', code: 'AS'}, 
                {name: 'AndorrA', code: 'AD'}, 
                {name: 'Angola', code: 'AO'}, 
                {name: 'Anguilla', code: 'AI'}, 
                {name: 'Antarctica', code: 'AQ'}, 
                {name: 'Antigua and Barbuda', code: 'AG'}, 
                {name: 'Argentina', code: 'AR'}, 
                {name: 'Armenia', code: 'AM'}, 
                {name: 'Aruba', code: 'AW'}, 
                {name: 'Australia', code: 'AU'}, 
                {name: 'Austria', code: 'AT'}, 
                {name: 'Azerbaijan', code: 'AZ'}, 
                {name: 'Bahamas', code: 'BS'}, 
                {name: 'Bahrain', code: 'BH'}, 
                {name: 'Bangladesh', code: 'BD'}, 
                {name: 'Barbados', code: 'BB'}, 
                {name: 'Belarus', code: 'BY'}, 
                {name: 'Belgium', code: 'BE'}, 
                {name: 'Belize', code: 'BZ'}, 
                {name: 'Benin', code: 'BJ'}, 
                {name: 'Bermuda', code: 'BM'}, 
                {name: 'Bhutan', code: 'BT'}, 
                {name: 'Bolivia', code: 'BO'}, 
                {name: 'Bosnia and Herzegovina', code: 'BA'}, 
                {name: 'Botswana', code: 'BW'}, 
                {name: 'Bouvet Island', code: 'BV'}, 
                {name: 'Brazil', code: 'BR'}, 
                {name: 'British Indian Ocean Territory', code: 'IO'}, 
                {name: 'Brunei Darussalam', code: 'BN'}, 
                {name: 'Bulgaria', code: 'BG'}, 
                {name: 'Burkina Faso', code: 'BF'}, 
                {name: 'Burundi', code: 'BI'}, 
                {name: 'Cambodia', code: 'KH'}, 
                {name: 'Cameroon', code: 'CM'}, 
                {name: 'Canada', code: 'CA'}, 
                {name: 'Cape Verde', code: 'CV'}, 
                {name: 'Cayman Islands', code: 'KY'}, 
                {name: 'Central African Republic', code: 'CF'}, 
                {name: 'Chad', code: 'TD'}, 
                {name: 'Chile', code: 'CL'}, 
                {name: 'China', code: 'CN'}, 
                {name: 'Christmas Island', code: 'CX'}, 
                {name: 'Cocos (Keeling) Islands', code: 'CC'}, 
                {name: 'Colombia', code: 'CO'}, 
                {name: 'Comoros', code: 'KM'}, 
                {name: 'Congo', code: 'CG'}, 
                {name: 'Congo, The Democratic Republic of the', code: 'CD'}, 
                {name: 'Cook Islands', code: 'CK'}, 
                {name: 'Costa Rica', code: 'CR'}, 
                {name: 'Cote D\'Ivoire', code: 'CI'}, 
                {name: 'Croatia', code: 'HR'}, 
                {name: 'Cuba', code: 'CU'}, 
                {name: 'Cyprus', code: 'CY'}, 
                {name: 'Czech Republic', code: 'CZ'}, 
                {name: 'Denmark', code: 'DK'}, 
                {name: 'Djibouti', code: 'DJ'}, 
                {name: 'Dominica', code: 'DM'}, 
                {name: 'Dominican Republic', code: 'DO'}, 
                {name: 'Ecuador', code: 'EC'}, 
                {name: 'Egypt', code: 'EG'}, 
                {name: 'El Salvador', code: 'SV'}, 
                {name: 'Equatorial Guinea', code: 'GQ'}, 
                {name: 'Eritrea', code: 'ER'}, 
                {name: 'Estonia', code: 'EE'}, 
                {name: 'Ethiopia', code: 'ET'}, 
                {name: 'Falkland Islands (Malvinas)', code: 'FK'}, 
                {name: 'Faroe Islands', code: 'FO'}, 
                {name: 'Fiji', code: 'FJ'}, 
                {name: 'Finland', code: 'FI'}, 
                {name: 'France', code: 'FR'}, 
                {name: 'French Guiana', code: 'GF'}, 
                {name: 'French Polynesia', code: 'PF'}, 
                {name: 'French Southern Territories', code: 'TF'}, 
                {name: 'Gabon', code: 'GA'}, 
                {name: 'Gambia', code: 'GM'}, 
                {name: 'Georgia', code: 'GE'}, 
                {name: 'Germany', code: 'DE'}, 
                {name: 'Ghana', code: 'GH'}, 
                {name: 'Gibraltar', code: 'GI'}, 
                {name: 'Greece', code: 'GR'}, 
                {name: 'Greenland', code: 'GL'}, 
                {name: 'Grenada', code: 'GD'}, 
                {name: 'Guadeloupe', code: 'GP'}, 
                {name: 'Guam', code: 'GU'}, 
                {name: 'Guatemala', code: 'GT'}, 
                {name: 'Guernsey', code: 'GG'}, 
                {name: 'Guinea', code: 'GN'}, 
                {name: 'Guinea-Bissau', code: 'GW'}, 
                {name: 'Guyana', code: 'GY'}, 
                {name: 'Haiti', code: 'HT'}, 
                {name: 'Heard Island and Mcdonald Islands', code: 'HM'}, 
                {name: 'Holy See (Vatican City State)', code: 'VA'}, 
                {name: 'Honduras', code: 'HN'}, 
                {name: 'Hong Kong', code: 'HK'}, 
                {name: 'Hungary', code: 'HU'}, 
                {name: 'Iceland', code: 'IS'}, 
                {name: 'India', code: 'IN'}, 
                {name: 'Indonesia', code: 'ID'}, 
                {name: 'Iran, Islamic Republic Of', code: 'IR'}, 
                {name: 'Iraq', code: 'IQ'}, 
                {name: 'Ireland', code: 'IE'}, 
                {name: 'Isle of Man', code: 'IM'}, 
                {name: 'Israel', code: 'IL'}, 
                {name: 'Italy', code: 'IT'}, 
                {name: 'Jamaica', code: 'JM'}, 
                {name: 'Japan', code: 'JP'}, 
                {name: 'Jersey', code: 'JE'}, 
                {name: 'Jordan', code: 'JO'}, 
                {name: 'Kazakhstan', code: 'KZ'}, 
                {name: 'Kenya', code: 'KE'}, 
                {name: 'Kiribati', code: 'KI'}, 
                {name: 'Korea, Democratic People\'S Republic of', code: 'KP'}, 
                {name: 'Korea, Republic of', code: 'KR'}, 
                {name: 'Kuwait', code: 'KW'}, 
                {name: 'Kyrgyzstan', code: 'KG'}, 
                {name: 'Lao People\'S Democratic Republic', code: 'LA'}, 
                {name: 'Latvia', code: 'LV'}, 
                {name: 'Lebanon', code: 'LB'}, 
                {name: 'Lesotho', code: 'LS'}, 
                {name: 'Liberia', code: 'LR'}, 
                {name: 'Libyan Arab Jamahiriya', code: 'LY'}, 
                {name: 'Liechtenstein', code: 'LI'}, 
                {name: 'Lithuania', code: 'LT'}, 
                {name: 'Luxembourg', code: 'LU'}, 
                {name: 'Macao', code: 'MO'}, 
                {name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK'}, 
                {name: 'Madagascar', code: 'MG'}, 
                {name: 'Malawi', code: 'MW'}, 
                {name: 'Malaysia', code: 'MY'}, 
                {name: 'Maldives', code: 'MV'}, 
                {name: 'Mali', code: 'ML'}, 
                {name: 'Malta', code: 'MT'}, 
                {name: 'Marshall Islands', code: 'MH'}, 
                {name: 'Martinique', code: 'MQ'}, 
                {name: 'Mauritania', code: 'MR'}, 
                {name: 'Mauritius', code: 'MU'}, 
                {name: 'Mayotte', code: 'YT'}, 
                {name: 'Mexico', code: 'MX'}, 
                {name: 'Micronesia, Federated States of', code: 'FM'}, 
                {name: 'Moldova, Republic of', code: 'MD'}, 
                {name: 'Monaco', code: 'MC'}, 
                {name: 'Mongolia', code: 'MN'}, 
                {name: 'Montserrat', code: 'MS'}, 
                {name: 'Morocco', code: 'MA'}, 
                {name: 'Mozambique', code: 'MZ'}, 
                {name: 'Myanmar', code: 'MM'}, 
                {name: 'Namibia', code: 'NA'}, 
                {name: 'Nauru', code: 'NR'}, 
                {name: 'Nepal', code: 'NP'}, 
                {name: 'Netherlands', code: 'NL'}, 
                {name: 'Netherlands Antilles', code: 'AN'}, 
                {name: 'New Caledonia', code: 'NC'}, 
                {name: 'New Zealand', code: 'NZ'}, 
                {name: 'Nicaragua', code: 'NI'}, 
                {name: 'Niger', code: 'NE'}, 
                {name: 'Nigeria', code: 'NG'}, 
                {name: 'Niue', code: 'NU'}, 
                {name: 'Norfolk Island', code: 'NF'}, 
                {name: 'Northern Mariana Islands', code: 'MP'}, 
                {name: 'Norway', code: 'NO'}, 
                {name: 'Oman', code: 'OM'}, 
                {name: 'Pakistan', code: 'PK'}, 
                {name: 'Palau', code: 'PW'}, 
                {name: 'Palestinian Territory, Occupied', code: 'PS'}, 
                {name: 'Panama', code: 'PA'}, 
                {name: 'Papua New Guinea', code: 'PG'}, 
                {name: 'Paraguay', code: 'PY'}, 
                {name: 'Peru', code: 'PE'}, 
                {name: 'Philippines', code: 'PH'}, 
                {name: 'Pitcairn', code: 'PN'}, 
                {name: 'Poland', code: 'PL'}, 
                {name: 'Portugal', code: 'PT'}, 
                {name: 'Puerto Rico', code: 'PR'}, 
                {name: 'Qatar', code: 'QA'}, 
                {name: 'Reunion', code: 'RE'}, 
                {name: 'Romania', code: 'RO'}, 
                {name: 'Russian Federation', code: 'RU'}, 
                {name: 'RWANDA', code: 'RW'}, 
                {name: 'Saint Helena', code: 'SH'}, 
                {name: 'Saint Kitts and Nevis', code: 'KN'}, 
                {name: 'Saint Lucia', code: 'LC'}, 
                {name: 'Saint Pierre and Miquelon', code: 'PM'}, 
                {name: 'Saint Vincent and the Grenadines', code: 'VC'}, 
                {name: 'Samoa', code: 'WS'}, 
                {name: 'San Marino', code: 'SM'}, 
                {name: 'Sao Tome and Principe', code: 'ST'}, 
                {name: 'Saudi Arabia', code: 'SA'}, 
                {name: 'Senegal', code: 'SN'}, 
                {name: 'Serbia and Montenegro', code: 'CS'}, 
                {name: 'Seychelles', code: 'SC'}, 
                {name: 'Sierra Leone', code: 'SL'}, 
                {name: 'Singapore', code: 'SG'}, 
                {name: 'Slovakia', code: 'SK'}, 
                {name: 'Slovenia', code: 'SI'}, 
                {name: 'Solomon Islands', code: 'SB'}, 
                {name: 'Somalia', code: 'SO'}, 
                {name: 'South Africa', code: 'ZA'}, 
                {name: 'South Georgia and the South Sandwich Islands', code: 'GS'}, 
                {name: 'Spain', code: 'ES'}, 
                {name: 'Sri Lanka', code: 'LK'}, 
                {name: 'Sudan', code: 'SD'}, 
                {name: 'Suriname', code: 'SR'}, 
                {name: 'Svalbard and Jan Mayen', code: 'SJ'}, 
                {name: 'Swaziland', code: 'SZ'}, 
                {name: 'Sweden', code: 'SE'}, 
                {name: 'Switzerland', code: 'CH'}, 
                {name: 'Syrian Arab Republic', code: 'SY'}, 
                {name: 'Taiwan, Province of China', code: 'TW'}, 
                {name: 'Tajikistan', code: 'TJ'}, 
                {name: 'Tanzania, United Republic of', code: 'TZ'}, 
                {name: 'Thailand', code: 'TH'}, 
                {name: 'Timor-Leste', code: 'TL'}, 
                {name: 'Togo', code: 'TG'}, 
                {name: 'Tokelau', code: 'TK'}, 
                {name: 'Tonga', code: 'TO'}, 
                {name: 'Trinidad and Tobago', code: 'TT'}, 
                {name: 'Tunisia', code: 'TN'}, 
                {name: 'Turkey', code: 'TR'}, 
                {name: 'Turkmenistan', code: 'TM'}, 
                {name: 'Turks and Caicos Islands', code: 'TC'}, 
                {name: 'Tuvalu', code: 'TV'}, 
                {name: 'Uganda', code: 'UG'}, 
                {name: 'Ukraine', code: 'UA'}, 
                {name: 'United Arab Emirates', code: 'AE'}, 
                {name: 'United Kingdom', code: 'GB'}, 
                {name: 'United States', code: 'US'}, 
                {name: 'United States Minor Outlying Islands', code: 'UM'}, 
                {name: 'Uruguay', code: 'UY'}, 
                {name: 'Uzbekistan', code: 'UZ'}, 
                {name: 'Vanuatu', code: 'VU'}, 
                {name: 'Venezuela', code: 'VE'}, 
                {name: 'Viet Nam', code: 'VN'}, 
                {name: 'Virgin Islands, British', code: 'VG'}, 
                {name: 'Virgin Islands, U.S.', code: 'VI'}, 
                {name: 'Wallis and Futuna', code: 'WF'}, 
                {name: 'Western Sahara', code: 'EH'}, 
                {name: 'Yemen', code: 'YE'}, 
                {name: 'Zambia', code: 'ZM'}, 
                {name: 'Zimbabwe', code: 'ZW'} 
              ]
           
              var access_key = '349640ba6d7fbda1f526e45d7ac22a48';
              var url = 'https://api.ipapi.com/api/check?access_key=' + access_key;
             
              fetch(url)
              .then(response => response.json())
              .then(function(data) {
                console.log(data);
                // var postal  = "83713";
                // var countryCode = "US";
                // var region = "Idaho";

                var postal  = data.zip;
                var countryCode = data.country_code;
                var region = data.region_name;
                var allowCartZipUpdate = false;
                
                _this.querySelector('.custom_zip_code').innerHTML = postal; 
                _this.querySelector('#address_zip').innerHTML = postal; 
               
                
                let currentCountryName = '';

                for (const countryObj of all_counties_arr) {
                  if (countryObj.code === countryCode) {
                    currentCountryName = countryObj.name;
                    break;
                  }
                }

                const countrySelect = _this.querySelector('#address_country');
                let findRegion = false;

                if (countrySelect) {
                  const options = [...countrySelect.options];

                  findRegion = options.some(option => option.value === currentCountryName);
                }

                if(findRegion) {
                  _this.querySelector("#address_country").value = currentCountryName;                 
                  var t=_this.querySelectorAll('#address_country option')[_this.querySelector('#address_country').selectedIndex],
                  e=t.getAttribute("data-provinces"),
                  n=JSON.parse(e);
                  
                  
                  if(n&&0==n.length){
                    _this.querySelector('#address_province').style.display = "none";
                  }else{
                    _this.querySelector("#address_province").options.length = 0;
                    for(var i=0;i<n.length;i++){
                      var t= document.createElement("option");
                      t.value=n[i][0],
                        t.innerHTML=n[i][1];
                      _this.querySelector('#address_province').appendChild(t);
                    }
                  }

                  _this.querySelector('#address_province').value = region;
                  _this.classList.add('active');
                 
                }
                
              });

              document.body.addEventListener('click', (e) => {
              const changeZipBtn = e.target.closest('.change_zip_code');
              const closeBtn = e.target.closest('.product_shipping_info_modal__close');
              const modal = document.querySelector('.product_shipping_info_modal'); 

              // Change zip code
              if (changeZipBtn) {
                e.preventDefault();

                const zipInput = document.querySelector('#address_zip');
                const zipCode = zipInput?.value.trim();

                if (zipCode) {
                  const zipDisplay = document.querySelector('.custom_zip_code');
                  if (zipDisplay) {
                    zipDisplay.textContent = zipCode;
                  }

                  const wrapper = changeZipBtn.closest('.customer_info_form__wrapper');
                  wrapper?.classList.toggle('active');
                }
              }

                // Close button click
              if (closeBtn) {
                e.preventDefault();

                const parentModal = closeBtn.closest('.product_shipping_info_modal');
                if (parentModal) {
                  parentModal.classList.remove('active');
                  const wrapper = parentModal.querySelector('#wrapper-response');
                  if (wrapper) wrapper.innerHTML = '';
                }
                return;
              }

              // Click outside modal
              if (modal && modal.classList.contains('active')) {
                if (!modal.contains(e.target)) {
                  modal.classList.remove('active');
                  const wrapper = modal.querySelector('#wrapper-response');
                  if (wrapper) wrapper.innerHTML = '';
                }
              }

            });    
            
            
            document.body.addEventListener('click', async (e) => {
            const button = e.target.closest('.check_shipping_info');
            if (!button) return;

            e.preventDefault();

            // UI state
            button.classList.add('disabled');
            _this.querySelector('.product_shipping_info__loader')
              ?.classList.add('active');

            const errorBox = _this.querySelector('.product_shipping_info_error');
            if (errorBox) {
              errorBox.classList.remove('active');
              errorBox.innerHTML = '';
            }

            const cartItemCount = document.querySelector("#cart-notification-count").innerHTML;

            const zipCode = _this.querySelector('.custom_zip_code')
              ?.textContent.trim();

            if (!zipCode) return;

            const shippingAddress = {
              zip: zipCode,
              country: _this.querySelector('#address_country')?.value,
              province: _this.querySelector('#address_province')?.value
            };

            const closeModal = () => {
              _this.querySelector('.product_shipping_info_modal')
                ?.classList.remove('active');
              _this.querySelector('#wrapper-response')
                ?.replaceChildren();
            };

            // 🟢 CASE 1: Cart already has items
            if (cartItemCount !== '0') {
              closeModal();
              _this._getCartShippingRatesForDestination(shippingAddress);
              return;
            }

            // 🟢 CASE 2: Cart empty → Add item first
            const itemId = Number(button.dataset.id);

            try {
              await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                  'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                  quantity: 1,
                  id: itemId
                })
              });

              // Preserve original logic
              window.removeCartItems = true;
                _this.querySelector('.product_shipping_info_modal').classList.remove('active');
                _this.querySelector('#wrapper-response').innerHTML = "";
              closeModal();
              _this._getCartShippingRatesForDestination(shippingAddress);

            } catch (err) {
              console.error('Cart add failed', err);
            }
          });

              
              this._config = {
                submitButton: 'Calculate shipping', 
                submitButtonDisabled: 'Calculating...',
                templateId: 'shipping-calculator-response-template',
                wrapperId: 'wrapper-response',
                customerIsLoggedIn: false,
                moneyFormat: '$\{\{amount\}\}'
              };  
              
              window.removeCartItems = false;
          

  }   
            _render(response) {
              
                var _this = this;  
                var template = _this.querySelector('#' + _this._config.templateId);
                var wrapper = _this.querySelector('#' + _this._config.wrapperId);
               // debugger;
                if (template && wrapper) {
                  _.templateSettings = {
                    evaluate: /<%([\s\S]+?)%>/g,
                    interpolate: /<%=([\s\S]+?)%>/g,
                    escape: /<%-([\s\S]+?)%>/g
                  };

                  var myTemplate = _.template(template.innerText.trim());                
                  var compiled = myTemplate(response).replace("province", "State");
                  //wrapper.appendChild(compiled);
                  wrapper.insertAdjacentHTML(
                  'afterbegin',
                  compiled
                );
                }
              };  

              async _getCartShippingRatesForDestination(shippingAddress) {
              var _this = this;  
              const wrapper = _this.querySelector('#wrapper-response');
              wrapper?.classList.add('spinner');

              try {
                const response = await fetch('/cart/prepare_shipping_rates', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json'
                  },
                  body: JSON.stringify({ shipping_address: shippingAddress })
                });

                if(response.status >= 200 && response.status < 300) {
                   await _this._pollForCartShippingRates(shippingAddress);
                }else {
                    var errorResponse  = await response.json();
                   _this._onError(errorResponse);
                }  

              } catch (error) {
                _this._onError(error);
              }
            }

            async _pollForCartShippingRates(shippingAddress) {
              
              var _this = this;  
                const response = await fetch('/cart/async_shipping_rates');
              try {
                if (response.status === 200) {
                  const data = await response.json();

                  _this._onCartShippingRatesUpdate(
                    data.shipping_rates,
                    shippingAddress
                  );

                } else if(response.status > 200 && response.status < 300) {
                  // Retry after delay
                  setTimeout(
                    () => _this._pollForCartShippingRates(shippingAddress),
                    500
                  );
                }
               } catch (error) {
                  _this._onError(error);
                }
            }

              _fullMessagesFromErrors(errors = {}) {
                var fullMessages = [];
                return Object.entries(errors).flatMap(([attribute, messages]) =>
                    messages.map(message => `${attribute} ${message}`)
                  );
              };
              _onError(error) {
               var _this = this;  
               debugger;
                // Re-enable calculate shipping buttons.
                // Formatting error message.
                var feedback = "";
                if (typeof error == "object") {
                  feedback = 'Error : ' + _this._fullMessagesFromErrors(error).join('; ') + '.';
                } 
                else {
                 feedback = error;
                }    
                if (feedback === 'Error : country is not supported.') feedback = 'We do not ship to this destination.';
                // Update calculator.

                _this.querySelector('.product_shipping_info_error').innerHTML = feedback;
                _this.querySelector('.product_shipping_info_error').classList.add('active');
                _this.querySelector('.check_shipping_info').classList.remove('disabled');
                _this.querySelector('.product_shipping_info__loader').classList.remove('active');
                _this._render( { rates: [], errorFeedback: feedback, success: false } );
                _this.querySelector("#wrapper-response").classList.remove("spinner");
                _this.querySelector('#' + _this._config.wrapperId).style.display = "block";
              
              };  
              _onCartShippingRatesUpdate(rates, shipping_address){
                var _this = this;
                  // Formatting shipping address.
                var readable_address = '';
                if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
                if (shipping_address.province) readable_address += shipping_address.province + ', ';
                readable_address += shipping_address.country;
                // Show estimated shipping.
                if (rates.length) {
                  // if (rates[0].price == '0.00') {
                  //   _this.querySelector('#estimated-shipping em').innerHTML = 'FREE';
                  // }
                  // else {
                  //   _this.querySelector('#estimated-shipping em').innerHTML = _this._formatRate(rates[0].price);
                  // }
                  for (var i=0; i<rates.length; i++) {
                    rates[i].price = _this._formatRate(rates[i].price);
                  }
                }
                // Show rates and feedback.
                _this._render( { rates: rates, address: readable_address, success:true } );
                 _this.querySelector("#wrapper-response").classList.remove("spinner");
                 _this.querySelector("#wrapper-response").insertAdjacentHTML(
                  'afterbegin',
                  '<h4>Expedited options available at checkout</h4>'
                );


                /* ----------------------------------
                    Rate selection total update
                  -----------------------------------*/

                  const checkedRate = _this.querySelector('.rate__price_trigger:checked');

                  const totalPriceEl = _this.querySelector('.new-total-row .total-price');
                  const calculateShipText = _this.querySelector('.calculate_ship_text');

                  if (checkedRate && totalPriceEl && calculateShipText) {

                    const rateValue = Number(
                      checkedRate
                        .closest('li')
                        ?.querySelector('span.money')
                        ?.textContent
                        .replace('.', '')
                        .replace('$', '')
                    );

                    const baseTotal = Number(totalPriceEl.dataset.centvalue);

                    const newTotal = baseTotal + rateValue;

                    totalPriceEl.textContent = formatRate(newTotal);
                    calculateShipText.textContent = formatRate(rateValue);
                    calculateShipText.classList.add('money');

                  } else if (totalPriceEl && calculateShipText) {

                    const subtotal = _this.querySelector('.subtotal_shipping_price');

                    totalPriceEl.textContent = subtotal?.textContent ?? '';
                    calculateShipText.textContent = 'Free Ground';
                    calculateShipText.classList.remove('money');
                  }

                    /* ----------------------------------
                        Clear cart if needed
                      -----------------------------------*/

                      if (window.removeCartItems) {
                        fetch('/cart/clear.js', { method: 'POST' });
                      }

                      _this.querySelector('.product_shipping_info__loader')
                        ?.classList.remove('active');

                      _this.querySelector('.product_shipping_info_modal')
                        ?.classList.add('active');

                      _this.querySelectorAll('.check_shipping_info')
                        .forEach(btn => btn.classList.remove('disabled'));
                

              }
              // _onCartShippingRatesUpdate(rates, shipping_address) {

              

               
                // var vendor_prod = false;
                // var set_date_specific_vendor = Date.today().at("1:30pm");
                // var set_date_other_vendors = Date.today().at("1:30pm");   
                // var vendor_flag = true;
                // var vendor_flag_lew_electric = false;
                // var filter_pre_order = false;
                // // var arr_orders_id = _this.querySelector('.product_filter_tags').value; 
                // // var product_with_preorder_id = _this.querySelector('.order_prod_tags_id').value;  
                // var use_5pm_lew_electric = true;
                // var only_boise_in_cart = true;

                // // if(product_with_preorder_id != '') {
                // //   if(arr_orders_id.indexOf(product_with_preorder_id) + 1) {
                // //     filter_pre_order = true;        
                // //   }
                // // }  
                // _this.querySelectorAll('.vendor_name_prod').forEach(function(){

                //   if(($(this).data('vendor')) != undefined){

                   
                //     var shipping_message = $('.variant-inventory-text').html();


                //     if($(this).data('vendor') == "Hubbell" && vendor_flag){
                //      vendor_prod = true;
                //       set_date_specific_vendor = Date.today().at("5:00pm");
                //   }else{
                //     vendor_prod = false;
                //     vendor_flag = false
                //   }
            
                //     if($(this).data('vendor') == "Lew Electric" && vendor_flag_lew_electric) {          
                //       vendor_flag_lew_electric = true;          
                //     }else{
                //       vendor_flag_lew_electric = false;
                //     }
                //     if($(this).data('vendor') == "Lew Electric"){
                //       if( shipping_message.indexOf('Boise') > -1 && use_5pm_lew_electric) {
                //         set_date_other_vendors = Date.today().at("6:00pm");           
                //       } else {
                //         use_5pm_lew_electric = false;
                //         set_date_other_vendors = Date.today().at("1:30pm");
                //       }
                //     }
                    
                //     if( shipping_message.indexOf('Boise') == -1) {
                //     	only_boise_in_cart = false;
                //     }

                //   }
                // });  
                // var now_date = moment.tz("America/New_York").format('llll'); // time zona New York 
                // now_date = Date.parse(now_date); // convert time to date.js
                // //var now_date1 = Date.today().setTimeToNow();  // old day today

                
                // console.log(now_date);
                // var compare_date_for_others = Date.compare(now_date, set_date_other_vendors);  
                // var compare_date_for_specific = Date.compare(now_date, set_date_specific_vendor); 


                // if(only_boise_in_cart) {
                //   var holidays = $('.vendor_name_prod').attr('data-boise_holidays_day'); 
                // } else {
                //   var holidays = $('.vendor_name_prod').val(); 
                // }

                // var flag_holiday = true;
                // if(holidays == null || holidays == '') {
                //   flag_holiday = false;
                // }
                // holidays = holidays.split(','); 

                // var now_date_str = Date.today().toString("d/M/yyyy");
                // now_date_str = Date.parse(now_date_str);
		
		
                // $("#shipping-rates>li").each(function(){
                //   var compare_date_for_others_item = compare_date_for_others;
                //   var compare_date_for_specific_item = compare_date_for_specific;
                //   var li_text = $(this).text();     

                //    if(_.includes(li_text, "UPS Ground")){
                //     if(vendor_flag_lew_electric){
                //        var skip_days = 5;   
                //     }else{
                //        var skip_days = 5;   
                //       }
                //     var time_delivery = ' by end of day';
                //  }else if(_.includes(li_text, "UPS Standard")){
                //      var skip_days = 7; 
                //    	 var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "USPS Priority Mail Express")){
                //      var skip_days = 3; 
                //    	 var time_delivery = ' by end of day';
                //   }
                //   else if(_.includes(li_text, "UPS Worldwide Expedited")){
                //      var skip_days = 5; 
                //    	 var time_delivery = ' by end of day';
                //   }
                //    else if(_.includes(li_text, "UPS Saver") || _.includes(li_text, "UPS Worldwide Saver")){
                //      var skip_days = 3; 
                //    	 var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "USPS Priority Mail")){
                //      var skip_days = 6; 
                //    	 var time_delivery = ' by end of day';
                //   }
                //   else if(_.includes(li_text, "UPS Three-Day") || _.includes(li_text, "UPS 3 Day")){
                //      var skip_days = 3; 
                //    	 var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "UPS Second Day Air") || _.includes(li_text, "UPS 2nd Day Air")){
                //     var skip_days = 2; 
                //     var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "UPS Next Day Air Saver")){       
                //     var time_delivery = ' by end of day';
                //     var skip_days = 1; 
                //   }else if(_.includes(li_text, "Next Day Air Early")){
                //     var skip_days = 1; 
                //     var time_delivery = ' by 9:30am'; 
                //   }else if(_.includes(li_text, "UPS Next Day Air")){
                //     var skip_days = 1; 
                //     var time_delivery = ' by noon';     
                //   }else if(_.includes(li_text, "Free FedEx Ground Shipping")){
                //     var skip_days = 5; 
                //     var time_delivery = ' by end of day';   
                //   }else if(_.includes(li_text, "FedEx International Ground")){
                //     var skip_days = 7; 
                //     var time_delivery = ' by end of day';      
                //   }else if(_.includes(li_text, "FedEx International Economy")){
                //     var skip_days = 5; 
                //     var time_delivery = ' by end of day';      
                //   }else if(_.includes(li_text, "FedEx International Priority")){
                //     var skip_days = 3; 
                //     var time_delivery = ' by end of day';  
                //   }else if(_.includes(li_text, "FedEx Ground")){
                //        var skip_days = 5;   
                //     var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "FedEx Express Saver")){
                //        var skip_days = 3;   
                //     var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "FedEx 2 Day")){
                //        var skip_days = 2;   
                //     var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "FedEx Standard Overnight")){
                //        var skip_days = 1;   
                //     var time_delivery = ' by end of day';
                //   }else if(_.includes(li_text, "FedEx Priority Overnight")){
                //     var skip_days = 1;   
                //     var time_delivery = ' by noon';
                //   }else{
                //     var skip_days = null; 
                //   }
                
                //   if(skip_days && filter_pre_order == false ) {

                //     var arr_hourDiff = [];
                //     var boise_holidays_flag = false;

                     
                //         var invertory_text = $('.variant-inventory-text').html();
                //         var order_time = '';
                       
                        
                //         if(invertory_text.indexOf('Boise') + 1) {
                //         boise_holidays_flag = true;
                //         order_time = '6pm';
                //         } else if (invertory_text.indexOf('Augusta') + 1) {
                //         order_time = '2:00pm';
                //         } else if (invertory_text.indexOf('NC') + 1) {
                //         order_time = '1:30pm';
                //         }

                        
                //         var cutoff_time = Date.today().at(order_time);
                //         var current_time = moment.tz("America/New_York").format('LTS'); // time zona New York 


                //         current_time = Date.parse(current_time); // convert time to date.js
                //         var hourDiff = cutoff_time - current_time; //in ms


                      
                //         arr_hourDiff.push(hourDiff);

                    
                      


                //     var max = Math.min.apply( Math, arr_hourDiff );




                //     var day_shopping = Date.today();
                //     if(max <= 0){
                //       day_shopping = day_shopping.add(1).day();    
                //     }

                //     if(flag_holiday == true) {
                //       for(var i = 0; i < holidays.length; i++) {     
                //         if(Date.compare(day_shopping, Date.parse(holidays[i])) == 0) {
                //           day_shopping = day_shopping.add(1).day();              
                //           if(day_shopping.is().saturday() || day_shopping.is().sunday()) {
                //             day_shopping = day_shopping.next().monday();  

                //             compare_date_for_others_item = 0;
                //             compare_date_for_specific_item = 0;
                //           }         
                //         }
                //       }
                //     }



                //     if (day_shopping.is().saturday() || 
                //         day_shopping.is().sunday() || 
                //         (compare_date_for_others_item == 1 && vendor_prod == false &&  day_shopping.is().friday()) ||
                //         (compare_date_for_specific_item == 1 && vendor_prod == true &&  day_shopping.is().friday())) {  
                //       day_shopping = day_shopping.next().monday();  
                //       compare_date_for_others_item = 0;
                //       compare_date_for_specific_item = 0;
                //     }

                //     var fromDate = day_shopping.clone().addDays(skip_days);  


                //     if (!fromDate.is().saturday() && !fromDate.is().sunday()) { 
                //       var week_start_val = day_shopping.getWeek();
                //       var week_finish_val = fromDate.getWeek();

                //       if(week_finish_val>week_start_val){
                //         fromDate = fromDate.addDays((week_finish_val-week_start_val)*2);
                //       }
                //     }



                //     if(flag_holiday == true) {
                //       for(var i = 0; i < holidays.length; i++) {
                //         if(fromDate.is().saturday()) { 
                //           fromDate = fromDate.next().monday();
                //         }else if(fromDate.is().sunday()) { 
                //           fromDate = fromDate.next().monday().addDays(1);
                //         }

                //         if(Date.parse(holidays[i]).between(day_shopping,fromDate)) {  

                //           fromDate = fromDate.addDays(1);                
                //           if(fromDate.is().saturday()) { 
                //             fromDate = fromDate.next().monday();
                //           }else if(fromDate.is().sunday()) { 
                //             fromDate = fromDate.next().monday().addDays(1);
                //           }
                //         }
                //       }
                //     }

                //     if(fromDate.is().saturday()) { 
                //       fromDate = fromDate.next().monday();
                //     }else if(fromDate.is().sunday()) { 
                //       fromDate = fromDate.next().monday().addDays(1);
                //     }




                //     $(this).append("<span class='delivery_date'>"+fromDate.toString('dddd MMM. dS')+ time_delivery + "</span>");
                //   }
                // });
                
            

              // };


      _formatRate(cents) {
                 var _this = this;

                if (typeof cents == 'string') { cents = cents.replace('.',''); }
                var value = '';
                var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                var formatString = _this._config.moneyFormat;
                function defaultOption(opt, def) {
                  return (typeof opt == 'undefined' ? def : opt);
                }
                function formatWithDelimiters(number, precision, thousands, decimal) {
                  precision = defaultOption(precision, 2);
                  thousands = defaultOption(thousands, ',');
                  decimal   = defaultOption(decimal, '.');
                  if (isNaN(number) || number == null) { return 0; }
                  number = (number/100.0).toFixed(precision);
                  var parts   = number.split('.'),
                      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
                      cents   = parts[1] ? (decimal + parts[1]) : '';
                  return dollars + cents;
                }
                switch(formatString.match(placeholderRegex)[1]) {
                  case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                  case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                  case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                  case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
                }
                return formatString.replace(placeholderRegex, value);
      };
  }

customElements.define("product-shipping-info", ProductShippingInfo);